import { connect } from 'react-redux';
import PSTNComp from 'components/PSTN/PSTN';
import { selectCountry, handleFocus, handleBlur } from 'actions/JoinModal';
import {
  callSelectors,
  streamActions,
  callActions,
  pstnNumbersActions,
  pstnNumbersSelectors
} from '@lifesize/nucleus';
import { isCallConnected } from 'utils/call-utils';
import { reset } from 'redux-form';
import _get from 'lodash/get';

const mapStateToProps = (state, ownProps) => ({
  preferredNumber: pstnNumbersSelectors.pstnNumbersWithCountryName(state)[0],
  selectedCountry: _get(state, 'app.joinModal.selectedCountry'),
  extension: ownProps.extension ? ownProps.extension : null,
  isVisible: _get(state, 'app.joinModal.isPSTNFocused'),
  selectionIndex: _get(state, 'app.dropdown.selectionIndex'),
  searchString: _get(state, 'app.form.PSTN.values.PSTNSearch'),
  isInCall: isCallConnected(callSelectors.activeCallSelector(state))
});

const mapDispatchToProps = dispatch => ({
  selectCountry: (country) => {
    dispatch(reset('PSTN'));
    dispatch(selectCountry(country));
    dispatch(handleBlur());
  },
  handleFocus: () => {
    dispatch(handleFocus());
  },
  handleBlur: () => {
    dispatch(reset('PSTN'));
    dispatch(handleBlur());
  },
  onSwitchToComputerAudio: () => {
    dispatch(callActions.enableFarEndAudio());
    dispatch(streamActions.setAudioMuteState(false));
  },
  getPSTNNumbers: async () => dispatch(pstnNumbersActions.getAll())
});

export default connect(mapStateToProps, mapDispatchToProps)(PSTNComp);
